import { defineStore } from "pinia";
 

export const useAdvertisementStore = defineStore("advertisementStore", () => {
   

    async function createItems(items) {
        try {
          const data = await useNuxtApp().$apiAuth(`/api/ad/create`,{
            method: 'POST',
            use: 'customer',
            body:{
              ...items
            }
           })
            return {
              success: data?.success,
              data: data?.data,
              errorValidation: {}
            };
           
        } catch (error) {
          
          return {
            success: false,
            status: error.response?.status,
            data: null,
            errorValidation: error?.response?._data?.errors
          };
        }
      }
      async function paginateActive(filter) {
        try {
          const data = await useNuxtApp().$apiAuth(`/api/ad/list/paginate`,{
            method: 'GET',
            use: 'customer',
            params:{
              ...filter
            }
           })
            return {
              success: true,
              data: data?.data,
              errorValidation: {}
            };
        
        } catch (error) {
 
          return {
            success: false,
            status: error.response?.status,
            data: null,
            errorValidation: error?.response?._data?.errors
          };
        }
      }
      async function paginateInActive(filter) {
        try {
          const data = await useNuxtApp().$apiAuth(`/customer/inactive/items`,{
            method: 'GET',
            use: 'customer',
            params:{
              ...filter
            }
           })
            return {
              success: true,
              content: data?.items,
              errorValidation: {}
            };
           
        } catch (error) {
 
          return {
            success: false,
            status: error.response?.status,
            content: null,
            errorValidation: error?.response?._data?.errors
          };
        }
      }
      async function paginateFollowers(filter) {
        try {
          const data = await useNuxtApp().$apiAuth(`/customer/followers/items`,{
            method: 'GET',
            use: 'customer',
            params:{
              ...filter
            }
           })
            return {
              success: true,
              content: data?.items,
              errorValidation: {}
            };
        
        } catch (error) {
 
          return {
            success: false,
            status: error.response?.status,
            content: null,
            errorValidation: error?.response?._data?.errors
          };
        }
      }
      
      async function updateItems(items) {
        try {
          const data = await useNuxtApp().$apiAuthCustomer(`/api/ad/update`,{
            method: 'PUT',
            use: 'customer',
            body:{
              ...items
            }
           })
            return {
              success: data?.success,
              data: data?.data,
              errorValidation: {}
            };
           
        } catch (error) {
 
          return {
            success: false,
            status: error.response?.status,
            data: null,
            errorValidation: error?.response?._data?.errors
          };
        }
      }
      async function updateSellItems(id) {
        try {
          const data = await useNuxtApp().$apiAuth(`/api/ad/update/status`,{
            method: 'PUT',
            use: 'customer',
            params:{
              id: id
            }
           })
            return {
              success: data?.success,
              data: data?.data,
              errorValidation: {}
            };
          
        } catch (error) {
 
          return {
            success: false,
            status: error.response?.status,
            data: null,
            errorValidation: error?.response?._data?.errors
          };
        }
      }
    async function deleteImage(id, use) {
        try {
          const data = await useNuxtApp().$apiAuth(`/api/ad/img/delete/${id}`,{
            method: 'DELETE', 
            use: use     
          })
            return {
              success: data?.success,
              data: data?.data,
              errorValidation: {}
            };
           
        } catch (error) {

          return {
            success: false,
            status: error.response?.status,
            data: null,
            errorValidation: error?.response?._data?.errors
          };
        }
      }
      async function deleteImageAdmin(id, use) {
        try {
          const data = await useNuxtApp().$apiAuth(`/customer/image/delete/${id}`,{
            method: 'DELETE',     
            use: use 
          })
            return {
              success: data?.success,
              content: null,
              errorValidation: {}
            };
           
        } catch (error) {

          return {
            success: false,
            status: error.response?.status,
            content: null,
            errorValidation: error?.response?._data?.errors
          };
        }
      }
     
      async function deleteItems(id) {
        try {
          const data = await useNuxtApp().$apiAuth(`/api/ad/delete/${id}`,{
            method: 'DELETE',
            use: 'customer',      
          })
            return {
              success: data?.success,
              data: data?.data,
              errorValidation: {}
            };
        
        } catch (error) {
 
          return {
            success: false,
            status: error.response?.status,
            data: null,
            errorValidation: error?.response?._data?.errors
          };
        }
      }
      async function updateDisplayAdmin(items) {
        try {
          const data = await useNuxtApp().$apiAuth(`/api/ad/update/display`,{
            method: 'PUT',
            use: 'admin',
            body:{
              ...items
            }
           })
            return {
              success: data?.success,
              data: data?.data,
              errorValidation: {}
            };
           
        } catch (error) {
 
          return {
            success: false,
            status: error.response?.status,
            data: null,
            errorValidation: error?.response?._data?.errors
          };
        }
      }

      async function updateTopAdmin(items) {
        try {
          const data = await useNuxtApp().$apiAuth(`/api/ad/update/top`,{
            method: 'PUT',
            use: 'admin',
            body:{
              ...items
            }
           })
            return {
              success: data?.success,
              data: data?.data,
              errorValidation: {}
            };
 
        } catch (error) {
          
 
          return {
            success: false,
            status: error.response?.status,
            data: data?.data,
            errorValidation: error?.response?._data?.errors
          };
        }
      }
      async function updateTopCategoryAdmin(items) {
        try {
          const data = await useNuxtApp().$apiAuth(`/api/ad/update/top/category`,{
            method: 'PUT',
            use: 'admin',
            body:{
              ...items
            }
           })
            return {
              success: data?.success,
              data: data?.data,
              errorValidation: {}
            };
           
        } catch (error) {
 
          return {
            success: false,
            status: error.response?.status,
            data: null,
            errorValidation: error?.response?._data?.errors
          };
        }
      }
      async function renewalItems(id) {
        try {
          const data = await useNuxtApp().$apiAuthCustomer(`/api/ad/renew`,{
            method: 'PUT',
            use: 'customer',
            params:{
              id: id
            }
           })
            return {
              success: data?.success,
              data: data?.data,
              errorValidation: {}
            };
         
        } catch (error) {
 
          return {
            success: false,
            status: error.response?.status,
            data: null,
            errorValidation: error?.response?._data?.errors
          };
        }
      }
      async function renewalItemsAdmin(id) {
        try {
          const data = await useNuxtApp().$apiAuth(`/api/ad/renew`,{
            method: 'PUT',
            params:{
              id: id
            },
            use: 'admin',
           })
            return {
              success: data?.success,
              data: data?.data,
              errorValidation: {}
            };
         
        } catch (error) {
 
          return {
            success: false,
            status: error.response?.status,
            data: null,
            errorValidation: error?.response?._data?.errors
          };
        }
      }
      async function sendEmailRenewal(items) {
        try {
          const data = await useNuxtApp().$apiAuth(`/api/ad/send/mail/renew`,{
            method: 'POST',
            body:{
              id: items.id
            },
            use: 'admin'
           })

    
           
            return {
              success: data?.success,
              data: data?.data,
              errorValidation: {}
            };
           
        } catch (error) {
 
          return {
            success: false,
            status: error.response?.status,
            data: null,
            errorValidation: error?.response?._data?.errors
          };
        }
      }
      async function followerItems(id) {
        try {
          const data = await useNuxtApp().$apiAuthCustomer(`/api/customer/follow`,{
            method: 'POST',
            use: 'customer',
            body:{
              id: id
            }
           })

  
            return {
              success: data?.success,
              data: data,
              errorValidation: {}
            };
           
        } catch (error) {
 
          return {
            success: false,
            status: error.response?.status,
            data: null,
            errorValidation: error?.response?._data?.errors
          };
        }
      }
      async function followerAdCache(id) {
        try {
          const data = await useNuxtApp().$apiAuth(`/api/customer/follow/cache`,{
            method: 'POST',
            use: 'customer',
            body:{
              id: id
            }
           })

  
            return {
              success: data?.success,
              data: data,
              errorValidation: {}
            };
           
        } catch (error) {
 if(error?.response._data?.message == 'Unauthenticated.') {
  const Swal = (await import('sweetalert2')).default

   Swal.fire({
      title: 'Morate biti prijavljeni!',
      icon:  'warning'  ,
      position: 'center',
    })
 }
 
          return {
            success: false,
            status: error.response?.status,
            data: null,
            errorValidation: error?.response?._data?.errors
          };
        }
      }
      async function getAdvertisementById(id) {
        try {
          const data = await useNuxtApp().$apiAuth(`/api/ad/by/id`,{
            method: 'GET',
            use: 'customer',
            params:{
              id: id
            }
           })
      
            return {
              success: true,
              data: data?.data,
              errorValidation: {}
            };
          
        } catch (error) {
 
          return {
            success: false,
            status: error.response?.status,
            data: null,
            errorValidation: error?.response?._data?.errors
          };
        }
      }
      async function getAdvertisementByIdEdit(id) {
        try {
          const data = await useNuxtApp().$apiAuth(`/api/ad/by/id`,{
            method: 'GET',
            use: 'customer',
            params:{
              id: id,
              // API po ovome razlikuje formu za izmenu od stranice oglasa (praćenje ponašanja)
              source: 'edit'
            }
           })
      
            return {
              success: true,
              data: data?.data,
              errorValidation: {}
            };
           
        } catch (error) {
 
          return {
            success: false,
            status: error.response?.status,
            data: null,
            errorValidation: error?.response?._data?.errors
          };
        }
      }
      async function getItemsIndexPage() {
        try {
          const data = await useNuxtApp().$apiAuth(`/items/index/page`,{
            method: 'GET'
           })
            return {
              success: true,
              content: data?.items,
              errorValidation: {}
            };
         
        } catch (error) {
 
          return {
            success: false,
            status: error.response?.status,
            content: null,
            errorValidation: error?.response?._data?.errors
          };
        }
      }
return {
    deleteImage,
    deleteImageAdmin,
    createItems,
    updateItems,
    deleteItems,
    renewalItemsAdmin,
    updateTopAdmin,
    updateDisplayAdmin,
    updateTopCategoryAdmin,
    renewalItems,
    sendEmailRenewal,
    paginateActive,
    paginateInActive,
    paginateFollowers,
    followerItems,
    followerAdCache,
    getAdvertisementById,
    updateSellItems,
    getAdvertisementByIdEdit,
    getItemsIndexPage
}
})
